import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Injectable, Injector, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable({
  providedIn: 'root'
})
export class LoaderInterceptorService implements HttpInterceptor {

  private activeRequests = 0;
  private pendingStart: any = null;
  private pendingStop: any = null;
  private loaderStarted = false;
  private readonly skipUrls: string[] = [
    'payment/achallan/payment_data',
    '/api/captcha/',
    '/filingservice/v3/api/return_view_data',
    '/filingservice/v3/api/check-return-view',
    '/filingservice/v3/api/get-submission-including-dacon',
    '/filingservice/v3/api/detail-return/get'
  ];

  constructor(private injector: Injector, private ngZone: NgZone) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.shouldSkipLoader(req.url)) {
      return next.handle(req);
    }

    const loader = this.injector.get(NgxUiLoaderService);
    this.activeRequests++;

    if (this.activeRequests === 1) {
      this.scheduleStart(loader);
    } else {
      this.clearTimer('pendingStop');
    }

    return next.handle(req).pipe(
      finalize(() => {
        this.activeRequests--;
        if (this.activeRequests < 0) {
          this.activeRequests = 0;
        }
        if (this.activeRequests === 0) {
          this.scheduleStop(loader);
        }
      })
    );
  }

  private scheduleStart(loader: NgxUiLoaderService): void {
    this.clearTimer('pendingStop');
    if (this.pendingStart) {
      return;
    }
    this.pendingStart = setTimeout(() => {
      this.pendingStart = null;
      if (this.activeRequests > 0) {
        this.loaderStarted = true;
        this.ngZone.run(() => {
          loader.start();
        });
      }
    }, 0);
  }

  private scheduleStop(loader: NgxUiLoaderService): void {
    const started = this.loaderStarted;
    if (this.pendingStart && !started) {
      this.clearTimer('pendingStart');
      return;
    }
    this.clearTimer('pendingStart');
    this.clearTimer('pendingStop');
    this.pendingStop = setTimeout(() => {
      this.pendingStop = null;
      if (this.activeRequests === 0) {
        this.loaderStarted = false;
        this.ngZone.run(() => {
          loader.stop();
          loader.stopAll();
        });
      }
    }, 0);
  }

  private clearTimer(name: 'pendingStart' | 'pendingStop'): void {
    if (name === 'pendingStart' && this.pendingStart) {
      clearTimeout(this.pendingStart);
      this.pendingStart = null;
    }
    if (name === 'pendingStop' && this.pendingStop) {
      clearTimeout(this.pendingStop);
      this.pendingStop = null;
    }
  }

  private shouldSkipLoader(url: string): boolean {
    return this.skipUrls.some(skipUrl => url.includes(skipUrl));
  }

  public addSkipUrl(url: string): void {
    if (!this.skipUrls.includes(url)) {
      this.skipUrls.push(url);
    }
  }

  public removeSkipUrl(url: string): void {
    const index = this.skipUrls.indexOf(url);
    if (index > -1) {
      this.skipUrls.splice(index, 1);
    }
  }
}
